export const types = {
  achievements: "[GET] Achievements",
  addAchievements: "[POST] Achievements",
  removeAchievements: "[DELETE] Achievements",
};
